import React, { useState } from "react";
import { Pencil, Save, X, Loader2 } from "lucide-react";
import { api } from "@/lib/apiClient";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export const DeskripsiEditor = ({ joId, joNumber, value, onChanged, testIdPrefix }) => {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(value || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/job-orders/${joId}`, { deskripsi: text });
      toast.success(`Deskripsi JO ${joNumber} diperbarui`);
      setEditing(false);
      await onChanged?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal menyimpan deskripsi");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mt-4 rounded-xl border border-white/5 bg-slate-950/50 p-3" data-testid={`${testIdPrefix}-wrap-${joNumber}`}>
      <div className="flex items-center justify-between gap-3">
        <span className="text-[10px] uppercase tracking-[0.18em] text-slate-500">
          Deskripsi / Jenis Cetakan
        </span>
        {!editing && (
          <button
            data-testid={`${testIdPrefix}-edit-${joNumber}`}
            onClick={() => {
              setText(value || "");
              setEditing(true);
            }}
            className="inline-flex items-center gap-1.5 text-[11px] text-blue-300 hover:text-blue-200 transition-colors duration-200"
          >
            <Pencil className="w-3.5 h-3.5" /> Edit
          </button>
        )}
      </div>
      {editing ? (
        <div className="mt-2 space-y-2">
          <Textarea
            data-testid={`${testIdPrefix}-input-${joNumber}`}
            rows={3}
            value={text}
            onChange={(e) => setText(e.target.value)}
            className="bg-slate-900/70 border-white/10 text-sm"
          />
          <div className="flex items-center gap-2">
            <button
              data-testid={`${testIdPrefix}-save-${joNumber}`}
              onClick={save}
              disabled={saving}
              className="inline-flex items-center gap-1.5 rounded-lg border border-blue-400/30 bg-blue-500/10 px-2.5 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-blue-200 hover:bg-blue-500/20 disabled:opacity-40 transition-colors duration-200"
            >
              {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />}
              Simpan
            </button>
            <button
              data-testid={`${testIdPrefix}-cancel-${joNumber}`}
              onClick={() => setEditing(false)}
              className="inline-flex items-center gap-1.5 rounded-lg border border-white/10 bg-slate-900/70 px-2.5 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-300 hover:bg-slate-800 transition-colors duration-200"
            >
              <X className="w-3.5 h-3.5" /> Batal
            </button>
          </div>
        </div>
      ) : (
        <p
          data-testid={`${testIdPrefix}-text-${joNumber}`}
          className="mt-2 text-sm text-slate-200 whitespace-pre-wrap"
        >
          {value || <span className="text-slate-600">Belum ada deskripsi</span>}
        </p>
      )}
    </div>
  );
};
